import { useTranslation } from "react-i18next";
import {
  toolContent,
  toolContentHeadings,
  type Lang,
  type ToolContent as ToolContentData,
} from "../data/toolContent";

export function getToolContent(slug: string, language: string): ToolContentData | null {
  const lang: Lang = language.startsWith("ro") ? "ro" : "en";
  return toolContent[slug]?.[lang] ?? toolContent[slug]?.en ?? null;
}

export function ToolContent({ slug, name }: { slug: string; name: string }) {
  const { i18n } = useTranslation();
  const content = getToolContent(slug, i18n.language);
  if (!content) return null;
  const headings = toolContentHeadings[i18n.language.startsWith("ro") ? "ro" : "en"];

  return (
    <article className="tool-content">
      <section>
        <h2>{`${headings.about}: ${name}`}</h2>
        <p>{content.intro}</p>
      </section>
      <section>
        <h2>{headings.howTo}</h2>
        <ol>
          {content.steps.map((step) => (
            <li key={step}>{step}</li>
          ))}
        </ol>
      </section>
      <section>
        <h2>{headings.faq}</h2>
        <dl>
          {content.faq.map((item) => (
            <div className="tool-faq-item" key={item.q}>
              <dt>{item.q}</dt>
              <dd>{item.a}</dd>
            </div>
          ))}
        </dl>
      </section>
    </article>
  );
}
